export default __webpack_public_path__ + "static/media/11.8b47dd9a.jpg";